import { render } from "./WebhookDeleteDialog.vue?vue&type=template&id=76d4f822&scoped=true"
import script from "./WebhookDeleteDialog.vue?vue&type=script&lang=js"
export * from "./WebhookDeleteDialog.vue?vue&type=script&lang=js"

import "./WebhookDeleteDialog.vue?vue&type=style&index=0&id=76d4f822&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d4f822"]])

export default __exports__